import { Column, InlineNotification, Row } from "carbon-components-react";

export default function SuccessNotification({ title, subTitle }) {
    return (
        <Row>
            <Column>
                <InlineNotification title={title} subtitle={subTitle} kind="success" />
            </Column>
        </Row>
    )
}